import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {GuiPermissionsService} from '../_services/gui/gui-permissions.service';
import {switchMapIfFalse} from '../_utils/operators';
import {AuthenticationService} from '../_services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class TuAdminGuard  {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly guiPermissionsService = inject(GuiPermissionsService);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return switchMapIfFalse(this.authenticationService.isTuAdmin$, this.guiPermissionsService.companyAdminRedirectUrlTree$);
  }
}
